import {
  Dialog,
  DialogTitle,
  Typography,
  IconButton,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableRow,
  styled,
  tableCellClasses,
  Chip,
  Tooltip,
} from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: "2px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
interface catalogProps {
  isOpen: boolean;
  handleClose: () => void;
  products: any;
  isLoading: boolean;
}
const CatalogSyncedProducts: React.FunctionComponent<catalogProps> = ({
  isOpen,
  handleClose,
  products,
  isLoading,
}) => {
  return (
    <>
      <Dialog
        fullWidth
        open={isOpen}
        onClose={handleClose}
        PaperProps={{
          style: { minHeight: "40vh", maxHeight: "70vh" },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: "2px",
            paddingBottom: "2px",
          }}
        >
          <Typography color="primary" sx={{ fontWeight: "bold" }}>
            Synced Products
          </Typography>
          <IconButton
            onClick={() => {
              handleClose();
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Table sx={{ marginTop: 2 }} aria-label="customized table">
            <TableBody>
              <StyledTableRow
                sx={{
                  height: "40px",
                  backgroundColor: "rgba(0, 0, 0, 0.04) !important",
                }}
              >
                <StyledTableCell sx={{ color: "primary", fontWeight: "bold" }}>
                  Model
                </StyledTableCell>

                <StyledTableCell sx={{ color: "primary", fontWeight: "bold" }}>
                  Title
                </StyledTableCell>
                <StyledTableCell sx={{ color: "primary", fontWeight: "bold" }}>
                  DMS Dealer Id
                </StyledTableCell>
                <StyledTableCell sx={{ color: "primary", fontWeight: "bold" }}>
                  Action
                </StyledTableCell>
              </StyledTableRow>
              {isLoading ? (
                <StyledTableRow>
                  <StyledTableCell align="center" colSpan={5}>
                    Loading Products...
                  </StyledTableCell>
                </StyledTableRow>
              ) : products && products.length > 0 ? (
                products.map((item: any, index: number) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell
                      sx={{
                        maxWidth: "100px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Tooltip title={item?.model ?? ""}>
                        <span>{item?.model}</span>
                      </Tooltip>
                    </StyledTableCell>

                    <StyledTableCell
                      sx={{
                        maxWidth: "100px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Tooltip title={item?.title ?? ""}>
                        <span>{item?.title}</span>
                      </Tooltip>
                    </StyledTableCell>
                    <StyledTableCell>
                      {item?.dmsSetup?.dmsDealerId}
                    </StyledTableCell>
                    <StyledTableCell>
                      <Chip
                        size="small"
                        label="View"
                        color="success"
                        onClick={() => {
                          window.open(
                            `${item.dmsSetup?.shopifyUrl}/products/${item?.shopifyProductLink}`,
                            "_blank"
                          );
                        }}
                      />{" "}
                    </StyledTableCell>
                    {/* <StyledTableCell align="right">
                      {wg?.price?.toFixed(2) ?? 0}
                    </StyledTableCell> */}
                  </StyledTableRow>
                ))
              ) : (
                <StyledTableRow>
                  <StyledTableCell align="center" colSpan={5}>
                    No Product Found.
                  </StyledTableCell>
                </StyledTableRow>
              )}
            </TableBody>
          </Table>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CatalogSyncedProducts;
